import api from './api';

const squadService = {
    // Get all squadS
    getAllsquads: async (params = {}) => {
        const response = await api.get('/squads', { params });
        return response.data;
    },

    // Create new squads
    createsquads: async (squadsData) => {
        const response = await api.post('/squads', squadsData);
        return response.data;
    },

    updatesquads: async (id, squadsData) => {
        const response = await api.put(`/squads/${id}`, squadsData);
        return response.data;
    },

    // Get squads for a specific project
    getSquadsByProject: async (projectId) => {
        const response = await api.get('/squads', { params: { project_id: projectId } });
        return response.data.squads || [];
    },


};

export default squadService;


